module.exports = __webpack_public_path__ + "img/banner_phone_gj.606635bf.png";